// Language codes enum
export enum LANGUAGE_CODES {
  ENGLISH = "en",
  HINDI = "hi",
}

// Collection name mappings for different languages
export const COLLECTION_NAMES = "ryze-gums";

// Video Testimonial interface
export interface VideoTestimonial {
  id: string;
  name: string;
  videoUrl: string;
}

// Video thumbnail mapping
export const VIDEO_THUMBNAIL_MAP: { [key: string]: string } = {
  avinash: "/images/video/avinash.webp",
  mukul: "/images/video/mukul.webp",
  "sonu-singh": "/images/video/sonu.webp",
  suman: "/images/video/suman.webp",
  sumit: "/images/video/sumit.webp",
  "umesh-gupta": "/images/video/umesh.webp",
};

// English video testimonials data
export const ENGLISH_VIDEO_TESTIMONIALS: VideoTestimonial[] = [
  {
    id: "avinash",
    name: "Avinash",
    videoUrl:
      "https://drive.google.com/file/d/1V1MwgRKKzHSqe48L4Nu9qoHkjmdDKrAX/preview",
  },
  {
    id: "mukul",
    name: "Mukul",
    videoUrl:
      "https://drive.google.com/file/d/1Gt01jjmdIet6hXkmPPzzqykWqbLJ2iZU/preview",
  },
  {
    id: "sonu-singh",
    name: "Sonu Singh",
    videoUrl:
      "https://drive.google.com/file/d/1nLyVNOabJn5ET231U2KIhj0jbhZL0yKM/preview",
  },
  {
    id: "suman",
    name: "Suman",
    videoUrl:
      "https://drive.google.com/file/d/16fUAbhfwn6fGxVLpe24-MmGyNqjnuOT-/preview",
  },
  {
    id: "sumit",
    name: "Sumit",
    videoUrl:
      "https://drive.google.com/file/d/1-KAiREJUn_xhhUvd9GfZimBYWs6PMD3I/preview",
  },
  {
    id: "umesh-gupta",
    name: "Umesh Gupta",
    videoUrl:
      "https://drive.google.com/file/d/1mJ5pi-JR0y9MxpDQ2LwpVy8jZ7SVTzME/preview",
  },
];

// Hindi video testimonials data
export const HINDI_VIDEO_TESTIMONIALS: VideoTestimonial[] = [
  {
    id: "avinash",
    name: "अविनाश",
    videoUrl:
      "https://drive.google.com/file/d/1V1MwgRKKzHSqe48L4Nu9qoHkjmdDKrAX/preview",
  },
  {
    id: "mukul",
    name: "मुकुल",
    videoUrl:
      "https://drive.google.com/file/d/1Gt01jjmdIet6hXkmPPzzqykWqbLJ2iZU/preview",
  },
  {
    id: "sonu-singh",
    name: "सोनू सिंह",
    videoUrl:
      "https://drive.google.com/file/d/1nLyVNOabJn5ET231U2KIhj0jbhZL0yKM/preview",
  },
  {
    id: "suman",
    name: "सुमन",
    videoUrl:
      "https://drive.google.com/file/d/16fUAbhfwn6fGxVLpe24-MmGyNqjnuOT-/preview",
  },
  {
    id: "sumit",
    name: "सुमित",
    videoUrl:
      "https://drive.google.com/file/d/1-KAiREJUn_xhhUvd9GfZimBYWs6PMD3I/preview",
  },
  {
    id: "umesh-gupta",
    name: "उमेश गुप्ता",
    videoUrl:
      "https://drive.google.com/file/d/1mJ5pi-JR0y9MxpDQ2LwpVy8jZ7SVTzME/preview",
  },
];
